export default __webpack_public_path__ + "static/media/cmk2020-sciendo-baner.ef742466.jpg";